// src/components/store/sections/newsletter/NewsletterV50MinimalinlineIndigoPulse.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV50MinimalinlineIndigoPulse(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={50}
      archKey="minimal_inline"
      archLabel="Minimalist Inline Strip"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
